import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed" }
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "mb-12"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "media/logos/neoris-logo.svg",
    class: "h-70px"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-column-auto p-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center fw-bold fs-6" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted text-hover-primary px-2" }, " 2023 © Neoris ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_view)
    ]),
    _hoisted_4
  ]))
}